//
//
//
//
//
//
//
//

export default {
	name: "CaroFilterCheckbox",
	props: {
		data: Object,
		setFilterValue: Function,
		// executeSearch: Function
	},
	data() {
		return {};
	},
	computed: {
		model: {
			get() {
				return this.data.selected;
			},
			set(value) {
				this.setFilterValue(this.data, value);
			},
		},
	},
};
